/**
 * Relay for Orders
 */

import { graphql as gql } from 'react-relay';
const graphql = gql;

export const OrdersQuery = graphql`
  query order_Query($invoice_number: Int, $isDefaultRoute: Boolean!) {
    viewer{
      ...order_viewer
    }
  }
`;

export const OrderListQuery = graphql`
  query orderList_Query {
    viewer{
      ...orderList_viewer
    }
  }
`;

export const OrderListNode = graphql`
  fragment orderListNode on Order {
    id
    currency_code
    currency_rate
    invoice_number
    order_date
    payment_due_date
    payment_status
    total
    project_details {
      brand
      product
      reference
      po_number
      notes
    }
  }
`;

export const OrderFragment = graphql`
  fragment orderNode on Order {
    id
    currency_code
    currency_rate
    discount
    invoice_number
    order_date
    payment_due_date
    payment_received_date
    payment_status
    subtotal
    total
    license_line_items{
      ...licenseLineItem @relay(mask: false)
    }
    general_line_items{
      id
      description
      amount
      discount_amount
    }
    promo_code_line_item{
      id
      code
      discount_type
      discount_type_amount
    }
    tax_line_items{
      id
      priority
      tax_name
      rate
      amount
    }
    licensee_address{
      ...orderAddress @relay(mask: false)
    }
    billing_address{
      ...orderAddress @relay(mask: false)
    }
    project_details {
      brand
      product
      reference
      po_number
      notes
    }
    authorized_representative {
      name
      email
      phone
      role_id
      role{
        id
        name
      }
    }
  }
`;

export const OrderListFragment = graphql`
  fragment orderList_viewer on Viewer {
    my_orders {
      ...orderListNode @relay(mask: false)
    }
  }
`;

export const OrderPageFragment = graphql`
  fragment order_viewer on Viewer {
    my_orders {
      ...orderListNode @relay(mask: false)
    }
    order(invoice_number: $invoice_number) @skip(if: $isDefaultRoute) {
      ...orderNode @relay(mask: false)
    }
  }
`;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/relay/order.ts